import { PagedResult } from '@/models/CommonModels';
import { Vertrag, VertragAnalyse, VertragItem } from '@/models/VertragModels';

export type State = {
  vertraege: Array<Vertrag>;
  vertragItems: Array<VertragItem>;
  vertragPage: PagedResult<VertragItem>;
  vertragAnalysen: VertragAnalyse | null;
};

export const state: State = {
  vertraege:
    localStorage.getItem('vertraege') != null && localStorage.getItem('vertraege') !== undefined ? JSON.parse(localStorage.vertraege) : new Array<Vertrag>(),
  vertragItems:
    localStorage.getItem('vertragItems') != null && localStorage.getItem('vertragItems') !== undefined
      ? JSON.parse(localStorage.vertragItems)
      : new Array<VertragItem>(),
  vertragPage: {
    items: new Array<VertragItem>(),
    pageIndex: 1,
    pageSize: 25,
    totalCount: 0,
    totalPages: 0,
    hasPreviousPage: false,
    hasNextPage: false,
  },
  vertragAnalysen: null,
};
